import type { RefreshAttemptRequest, RefreshAttemptResponse } from '@/models'
import { HttpErrorService } from '@/services/HttpError.service'
import { authErrorHandbook } from '@/models/Errors'
import { HttpService } from '@/services/Http.service'

export class RefreshAttemptService {
  private endpoint = '/auth/refresh-attempt'
  private httpErrorService: HttpErrorService<keyof typeof authErrorHandbook>
  private httpService: HttpService

  constructor(httpService: HttpService) {
    this.httpService = httpService
    this.httpErrorService = new HttpErrorService(authErrorHandbook, 'refresh')
  }

  async post(body: RefreshAttemptRequest) {
    return await this.httpService
      .post<RefreshAttemptResponse>(this.endpoint, {
        fetchConfig: { body },
        requestConfig: {
          forceRequest: true,
          cancellable: true,
        },
      })
      .catch((error) => {
        throw this.httpErrorService.getThrowingError(
          error,
          this.endpoint,
          'refresh',
        )
      })
  }
}
